const DescriptionList = ({ label, content, isLoading, ...rest }) => {
  return (
    <dl {...rest}>
      {isLoading && (
        <div className="flex-1 space-y-2 py-1 animate-pulse">
          <div className="h-4 bg-gray-100 rounded w-3/5"></div>
          <div className="h-4 bg-gray-100 rounded w-4/5"></div>
        </div>
      )}
      {!isLoading && (
        <>
          <dt className="text-sm font-medium text-gray-400">{label}</dt>
          <dd className="text-sm mt-1 text-gray-500">{content}</dd>
        </>
      )}
    </dl>
  );
};

export default DescriptionList;
